import { useMutation } from '@tanstack/react-query';
import { api } from '@/api';
import { NewTXCentersFormBody, PatchTXCentersBodyFormBody } from '@/api/apis/facilities';
import { queryClient } from '@/queries';
import { txCenterQueries } from '@/queries/tx-centers';
import { txCentersQueryKeys } from '@/queries/tx-centers/tx-centers.keys';

export const useCreateTXCenterMutation = () => {
  return useMutation({
    mutationFn: (variables: NewTXCentersFormBody) => api.txcenter.createTXCenter(variables),
    meta: {
      invalidates: [txCentersQueryKeys.getList(), txCentersQueryKeys.getInfiniteList()],
    },
  });
};

export const useUpdateTXCenterMutation = () => {
  return useMutation({
    mutationFn: ({
      id,
      isOnlyNotesUpdate = false,
      ...body
    }: PatchTXCentersBodyFormBody & { id: string; isOnlyNotesUpdate?: boolean }) =>
      isOnlyNotesUpdate ? api.txcenter.updateTXCenterNotes(id, body) : api.txcenter.updateTXCenterById(id, body),
    meta: {
      invalidates: [txCentersQueryKeys.getList(), txCentersQueryKeys.getInfiniteList()],
    },
    onSuccess: (data, variables) => {
      queryClient.setQueryData(txCenterQueries.myItem().queryKey, data);
      queryClient.setQueryData(txCenterQueries.item(data.id).queryKey, data);
      queryClient.invalidateQueries({ queryKey: txCenterQueries.itemWithTXUsers(variables.id).queryKey });
    },
  });
};
